/**
 * @Author: v_jppjpeng
 * @Date: 2024-06-12 15:03:06
 * @Explain: 联系人 - 自定义字段
 */

/** 参数声明 */
export type ContactAttributesState = {
  attributesList: any[];
};

export type ModelType = {
  namespace: string;
  state: ContactAttributesState;
  reducers: {
    setAttributesList: (
      state: ContactAttributesState,
      action: { payload: any },
    ) => any;
  };
};

const ContactAttributesModel: ModelType = {
  namespace: 'ContactAttributesModel',
  state: {
    attributesList: [],
  },
  reducers: {
    /** 设置自定义字段 */
    setAttributesList(state, action) {
      return {
        ...state,
        attributesList: action.payload,
      };
    },
  },
};

export default ContactAttributesModel;
